import { createContext } from 'react';

export const AdminAuthContext = createContext({});